import React, { cloneElement, isValidElement, useId } from 'react';
import Input from './Input';

export default function FormField({
  label,
  error,
  helper,
  required = false,
  className = '',
  children,
  ...inputProps
}) {
  const autoId = useId();
  const childId = isValidElement(children) ? children.props?.id : undefined;
  const fieldId = childId || inputProps.id || autoId;
  const describedById = error || helper ? `${fieldId}-desc` : undefined;
  const hasError = Boolean(error);

  const control = isValidElement(children)
    ? cloneElement(children, {
        id: fieldId,
        'aria-invalid': hasError || undefined,
        'aria-describedby': describedById,
      })
    : (
      <Input
        id={fieldId}
        error={hasError}
        aria-invalid={hasError || undefined}
        aria-describedby={describedById}
        {...inputProps}
      />
    );

  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      {label && (
        <label
          htmlFor={fieldId}
          className="text-base sm:text-sm font-medium text-gray-700"
        >
          {label}
          {required && <span className="text-red-500 ml-0.5" aria-hidden="true">*</span>}
        </label>
      )}
      {control}
      {(error || helper) && (
        <p
          id={describedById}
          className={`text-sm ${hasError ? 'text-red-600' : 'text-gray-500'}`}
        >
          {error || helper}
        </p>
      )}
    </div>
  );
}
